import Vue from 'vue';
import store from './../../store';
import transTransformer from './../../transformers/warehouseTransaction';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const transactions = transTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllWarehouseTransactions', transactions);
  resolve(transactions);
};

const failed = (error, reject) => reject();


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl(`warehouses/${options.id}/transactions`, options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/transactions.js